<template>
  <div class="addEmployeeAdminVue">
      <!-- HUGE COMMENT -->
        <!-- Please add autocomplete='off' to all input fields or at form level -->

    <div class="c-responsive-fixwidth">
       <div class="clearfix o-skillset-area">
           <div class="employer-info">
               <div class="field-group">
                   <div class="row">
                       <div class="col-sm-12">
                           <div class="c-common-space c-common-box-shadow c-radius3">
                               <div class="c-user-tab-content clearfix o-skillset-area">
                                   <p>Basic Info:</p>
                                   <div v-loading="loading" class="field-group">
                                        <div class="row">
                                           <div class="col-sm-3">
                                                <div class="form-group">
                                                    <label class="common-label-text form-label">Select Status:<span class="req-text">*</span></label>
                                                    <div class="o-cutsomSelect">
                                                        <select @change="onUpdateInputField" v-model="adminSettings.status" v-validate="{ required: true}" class="form-control" @blur="blur($event)" name="status" data-vv-delay="500">
                                                           <option value="">— None Assigned —</option>
                                                            <option v-for="status in statusList" :value="status.id">{{status.name}}</option>
                                                        </select>
                                                       <span v-show="errors.has('status') && this.validation_err!=0" class="err-msg">{{ errors.first('status') }}</span>
                                                              
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                   <div class="row">
                                       <div class="col-sm-3">
                                           <div class="form-group ">
                                               <label class="common-label-text">Member since:</label>
                                               <el-date-picker
                                                  @change="onUpdateInputField"
                                                  name="date"
                                                  v-validate="{ required: true}"
                                                  v-model="adminSettings.memberSince"
                                                  type="date"
                                                  :format="getDisplayFormat()"
                                                  value-format="yyyy-MM-dd"
                                                  :placeholder="getDatePlaceholder()">
                                               </el-date-picker>
                                               <!-- <input type="tel" class="form-control" placeholder="yyyyy-mm-dd"> -->
                                           </div>
                                       </div>
                                       <div class="col-sm-3">
                                           <div class="form-group ">
                                               <label class="common-label-text">Date of hire:</label>
                                               <el-date-picker
                                                  @change="onUpdateInputField"
                                                  name="date"
                                                  v-validate="{ required: true}"
                                                  v-model="adminSettings.dateOfHire"
                                                  type="date"
                                                  :format="getDisplayFormat()"
                                                  value-format="yyyy-MM-dd"
                                                  :placeholder="getDatePlaceholder()">
                                               </el-date-picker>
                                               <!-- <input type="tel" class="form-control" placeholder="yyyyy-mm-dd"> -->
                                           </div>
                                       </div>

                                       <div class="col-sm-3">
                                           <div class="form-group ">
                                               <label class="common-label-text">Total Shifts:</label>
                                               <input autocomplete="off" v-model="adminSettings.totalShifts" type="number" @change="onUpdateInputField" class="form-control" placeholder="Enter shift">
                                           </div>
                                       </div>
                                       <div class="col-sm-3">
                                           <div class="form-group ">
                                               <label class="common-label-text">Seniority:</label>
                                               <input autocomplete="off" v-model="adminSettings.seniority" type="number" @change="onUpdateInputField" class="form-control" placeholder="Enter seniority">
                                           </div>
                                       </div>
                                   </div>
                               </div>
                           </div>
                       </div>
                   </div>
               </div>
               

                
<!--
<div class="field-group">
    <div class="row">
        <div class="col-sm-6 o-margin-bottom-20">
            <div class="col-md-12 o-no-padding">
                <h5 class="h2">Notes:</h5>
            </div>
            <div class="col-md-12 o-no-padding">
                <div class="o-notes-toggle-container c-common-box-shadow c-radius3">

                    <div class="o-toggle-header js-active-togg">
                        <a href="javascript:void(0)" class="o-toggle-trigger"><i class="fa fa-minus-circle" aria-hidden="true"></i></a>
                        <div class="o-toggle-content">
                            <div class="js-note-txt-expand js-togg-expand-height">
                                <p class="ps1">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting.</p>
                            </div>
                            <h5 class="ps2">Created by: Me <a href=""><i class="fa fa-pencil" aria-hidden="true"></i></a></h5>
                        </div>
                    </div>
                    <div class="o-toggle-header">
                        <a href="javascript:void(0)" class="o-toggle-trigger"><i class="fa fa-plus-circle" aria-hidden="true"></i></a>
                        <div class="o-toggle-content">
                            <div class="js-note-txt-expand">
                                <p class="ps1">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting.</p>
                            </div>
                            <h5 class="ps2">Created by: Me <a href=""><i class="fa fa-pencil" aria-hidden="true"></i></a></h5>
                        </div>
                    </div>
                    <div class="o-toggle-header">
                        <a href="javascript:void(0)" class="o-toggle-trigger"><i class="fa fa-plus-circle" aria-hidden="true"></i></a>
                        <div class="o-toggle-content">
                            <div class="js-note-txt-expand">
                                <p class="ps1">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting.</p>
                            </div>
                            <h5 class="ps2">Created by: Me <a href=""><i class="fa fa-pencil" aria-hidden="true"></i></a></h5>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-12 o-no-padding">
                <a href="#" class="c-solid-btn c-solid-btn--large c-solid-btn--green"><i class="fa fa-plus" aria-hidden="true"></i> Add Note</a>
            </div>
        </div>

    </div>
</div>
-->
           </div>

       </div>
    </div>
  </div>
</template>
<script>
    import dateTimeConvert from '../../timeConvert&Compare';
    import {
        mapGetters,
        mapActions
    } from 'vuex';
    import service from '../../services.js';
    import {
        bus
    } from '../../main';
    export default {
        props: {
            adminSettingsData: {
                type: Object,
                required: true
            }
        },
        data() {
            return {
                validation_err: 0,
                statusList: [],
                loading: false,
                adminSettings: {
                    memberSince: '',
                    dateOfHire: '',
                    totalShifts: '',
                    seniority: '',
                    status: '',
                }
            }
        },
        computed: {
            ...mapGetters({
                userToken: 'userToken',
                userRole: 'userRole',
                userClientID: 'userClientID',
            })
        },
        methods: {
            getDisplayFormat(){
                var format = dateTimeConvert.getDateInputFormat();
                // console.log(format);
                return format?format:'MM/dd/yyyy';
            },
            getDatePlaceholder(){
                return dateTimeConvert.getDatePlaceHolder();
            },
            blur(event) {
                if ($(event.target).val() === "") {
                    $(event.target).siblings('.form-label').addClass('js-label-transition');
                    this.validation_err = 1;
                } else {
                    $(event.target).siblings('.form-label').removeClass('js-label-transition');
                    this.validation_err = 0;
                }
            },
            onUpdateInputField() {
                //this.$store.dispatch('saveEmployeeBasicInfo', this.empPersonal.basicInfo);
                if(this.adminSettings.seniority==0){
                  this.adminSettings.seniority='';
                }
                bus.$emit('onUpdateAdminSettings', this.adminSettings);
            }
        },
        created() {
            this.adminSettings = this.adminSettingsData;
            this.loading = true;
            service.get('employee/employee_status_lite', {
                'Authorization': this.userToken,
                'cs3-context-role': this.userRole,
                'cs3-context-clientId': this.userClientID
            }).
            then((res) => {
              this.statusList = res.data.result;
              this.statusList.sort(function(a, b) {
                  if (Number(a.priority) < Number(b.priority)) return -1;
                  if (Number(a.priority) > Number(b.priority)) return 1;
                  return 0;
              });

              this.loading = false;
                //console.log(this.statusList);

            }).catch((err) => {
                console.log(err);
                this.loading = false;
            });
        }
    }

</script>



// WEBPACK FOOTER //
// src/components/employees/addEmployeeAdmin.vue